export enum RPriceIdentifierEnum {
    R2,
    R3,
    R4,
    R5,
    R6,
    R7,
    R8,
    CUSTOM,
    DEFAULT_PAGE_PRICE
}

